<template>
  <div class="relative inline-block shrink-0">
    <img
      v-if="props.url"
      :class="[`rounded-full bg-gray-50 object-cover ${sizeClasses[props.size]}`]"
      :src="imgError ? props.fallbackUrl : props.url"
      :alt="props.alt"
      @error="handleError"
    />

    <div v-else :class="[`rounded-full text-black ${sizeClasses[props.size]} flex justify-center items-center ${fontSizeClasses[props.size]} bg-primary`]">
      {{ props.initials }}
    </div>

    <span
      v-if="props.dotted"
      :class="[
        `absolute bottom-0 right-0 block size-4 rounded-full bg-green-400 ring-2 ring-white ${sizeDottedClasses[props.size]}`,
      ]"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl";
  dotted?: boolean;
  url?: string;
  fallbackUrl?: string;
  alt: string;
  initials?: string
}

const imgError = ref(false);

const handleError = () => {
  imgError.value = true;
}

const props = withDefaults(defineProps<Props>(), {
  size: "md",
});

const sizeClasses = {
  xs: "size-6",
  sm: "size-8",
  md: "size-10",
  lg: "size-12",
  xl: "size-14",
  '2xl': "size-20",
  '3xl': "size-32",
};

const sizeDottedClasses = {
  xs: "size-1.5",
  sm: "size-2",
  md: "size-2.5",
  lg: "size-3",
  xl: "size-3.5",
  '2xl': "size-4",
  '3xl': "size-4",
};

const fontSizeClasses = {
  xs: "font-semibold text-xs",
  sm: "font-semibold text-sm",
  md: "font-semibold text-lg",
  lg: "font-semibold text-2xl",
  xl: "font-semibold text-4xl",
  '2xl': "font-semibold text-4xl",
  '3xl': "font-semibold text-4xl",
}
</script>